import moment from 'moment';
import fetch from 'services/request';
import {
  IApiBodyMergeTicket,
  IApiBodySplitTicket,
  IApiBodyVoidTicketOpen,
  IApiUpdateCashDeposit,
  ICreateCustomerBody,
  ISaveApiBodyType,
} from './types/api';
import { TYPE_GET_INFO_GIFT } from './constants';

const baseURL = 'api/v1';

export const getDetailsTicket = (checkInId: string) => {
  return fetch({
    method: 'get',
    url: `${baseURL}/check-in/detail/${checkInId}`,
  });
};

export const getDetailBill = (checkInId: string) => {
  return fetch({
    method: 'get',
    url: `${baseURL}/bill/detail/${checkInId}`,
  });
};

export const getCategories = () => {
  return fetch({
    method: 'get',
    url: `${baseURL}/category/get-all-by-category`,
  });
};

export const getStaffList = () => {
  const staffType = 'TECHNICAL';
  return fetch({
    method: 'get',
    url: `${baseURL}/staff/get-all-by-shop`,
    params: { staffType },
  });
};

export const editTicket = (body: ISaveApiBodyType) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/bill/${body.billId ? 'update-ticket' : 'save-ticket'}`,
    body,
  });
};

export const editTicketBackground = (body: ISaveApiBodyType) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/bill/${body.billId ? 'update-ticket' : 'save-ticket'}`,
    body,
    autoToast: true,
  });
};

export const getCustomerList = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/customer/list-active',
    params: { page: 1, size: 999999 },
  });
};

export const addNewCustomer = (body: ICreateCustomerBody) => {
  return fetch({
    method: 'post',
    url: 'api/v1/customer/create',
    body,
  });
};

export const addTicket = () => {
  return fetch({
    method: 'post',
    url: 'api/v1/bill/add-new-ticket',
    autoToast: false,
  });
};

export const getNumberTicket = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/bill/get-number-ticket',
    autoToast: false,
  });
};

export const getGiftCardInfo = (giftCode: string, type?: TYPE_GET_INFO_GIFT) => {
  return fetch({
    method: 'get',
    url: 'api/v1/gift-card/get-by-code',
    params: { giftCode, type },
  });
};

export const mergeTickets = (body: IApiBodyMergeTicket) => {
  return fetch({
    method: 'post',
    url: 'api/v1/bill/merge-ticket',
    body,
  });
};

export const splitTicket = (body: IApiBodySplitTicket) => {
  return fetch({
    method: 'post',
    url: 'api/v1/bill/split-ticket',
    body,
  });
};

export const getVIPPackageWithCustomerId = (customerId: string) => {
  return fetch({
    method: 'get',
    url: `api/v1/customer/discount-ticket/${customerId}`,
  });
};

export const getStampLoyaltyInfo = (customerId: string) => {
  return fetch({
    method: 'get',
    url: `api/v1/customer/stamp-loyalty-info/${customerId}`,
  });
};

export const voidTicketOpen = (body: IApiBodyVoidTicketOpen) => {
  return fetch({
    method: 'post',
    url: '/api/v1/payment/void-ticket-open',
    body,
  });
};

const checkReferralSender = (customerId: string, phoneReferral: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/customer/check-referral-sender',
    body: {
      customerId,
      phoneReferral,
    },
  });
};

const updateStaffTurnStatus = (body: {
  staffId: string;
  billId: string;
  finishTurn: boolean;
}) => {
  return fetch({
    method: 'post',
    url: '/api/v1/turn/update-turn-cashier',
    body: {
      staffId: body.staffId,
      billId: body.billId,
      type: body.finishTurn ? 'FINISH' : 'UNDO',
    },
  });
};

const getCashDeposit = () => fetch({
  method: 'get',
  url: '/api/v1/shop/cash-deposit',
  params: { date: moment().format('MM-DD-YYYY') }
});

const getCashDepositDetail = (cashDepositId: string) => fetch({
  method: 'get',
  url: `/api/v1/shop/cash-deposit/${cashDepositId}`,
});

const updateCashDeposit = (body: IApiUpdateCashDeposit) => fetch({
  method: 'post',
  url: '/api/v1/shop/cash-deposit',
  body,
});

const cashierApis = {
  getDetailsTicket,
  getDetailBill,
  getCategories,
  getStaffList,
  editTicket,
  getCustomerList,
  addNewCustomer,
  addTicket,
  getGiftCardInfo,
  mergeTickets,
  splitTicket,
  getVIPPackageWithCustomerId,
  getStampLoyaltyInfo,
  getNumberTicket,
  editTicketBackground,
  voidTicketOpen,
  checkReferralSender,
  updateStaffTurnStatus,
  updateCashDeposit,
  getCashDepositDetail,
  getCashDeposit,
};

export default cashierApis;
